import s from './theme.module.styl'
import React from 'react'
import t from '~t'
import { connect } from 'react-redux'
import { setTheme } from '~local/actions'

import { Label, Checkbox } from '~co/common/form'

class SettingsAppTheme extends React.PureComponent {
	themes = [
		['day', {app: 'day', sidebar: 'day'}],
		['night', {app: 'night', sidebar: 'night'}],
		['midnight', {app: 'day', sidebar: 'night'}],
		['sunset', {app: 'sunset', sidebar: 'sunset'}]
	]

	onThemeClick = e=>{
		e.preventDefault()

		this.props.setTheme(this.themes[parseInt(e.currentTarget.getAttribute('data-index'))][1])
	}

	onAutoThemeChange = e=>{
		const checked = e.target.checked
		if (checked) {
			this.props.setTheme({ ...this.props.theme, auto: true })
		} else {
			this.props.setTheme({ app: this.props.theme.app, sidebar: this.props.theme.sidebar })
		}
	}

	render() {
		const { theme } = this.props

		return (
			<>
				<Label>{t.s('interfaceStyle')}</Label>
				<div>
					<div className={s.selector} style={{marginBottom: 'var(--padding-medium)'}}>
						{this.themes.map(([key, item], index)=>
							<a
								key={key}
								className={s.theme}
								data-active={!theme.auto && item.app == theme.app && item.sidebar == theme.sidebar}
								data-index={index}
								tabIndex='0'
								href=''
								onClick={this.onThemeClick}>
								<div 
									data-theme={item.sidebar}
									className={s.sidebar}>
									――――
									――
									―――
								</div>

								<div 
									data-theme={item.app}
									className={s.main}>
									<span /><span />
									<span /><span />
									<span />
								</div>
							</a>
						)}
					</div>
					
					<Checkbox checked={theme.auto} onChange={this.onAutoThemeChange}>
						Automatic (Match OS Theme)
					</Checkbox>
				</div>
			</>
		)
	}
}

export default connect(
	(state)=>({
		theme: state.local.theme
	}),
	{ setTheme }
)(SettingsAppTheme)